// extracted by mini-css-extract-plugin
module.exports = {"secureText":"SecureText_secureText__2cO7z","icon":"SecureText_icon__r76-k"};